import { PriorAuthorizationControllerApi } from "../../../../services";
import {
  getXtenantId,
  getConfigObject,
  useMutationWithLoading,
} from "../../../../utils/utils";

interface Params {
  priorAuthorizationId: string;
}

/**
 * @author [Rajkumar Rathod]
 **/
export const useAuthorizationDownload = () =>
  useMutationWithLoading(async (params: Params) =>
    new PriorAuthorizationControllerApi(
      getConfigObject()
    ).generatePriorAuthorizationPdf(
      params?.priorAuthorizationId,
      getXtenantId(),
      {
        responseType: "blob",
      }
    )
  );
